import TableContainer from "@mui/material/TableContainer";
import { DataGrid } from "@mui/x-data-grid";

import TableFlexContainer from "../../../../../common/components/table/TableFlexContainer";
import TableNoDataOverlay from "../../../../../common/components/table/TableNoDataOverlay";
import { dataGridServerStyles } from "../../../../../common/providers/theme/design-tokens/DataGrid/dataGridServer.styles";
import { DEFAULT_COLUMN_HEADER_HEIGHT } from "../../../../../common/variables/common";
import { TablePaperContainer } from "../../../../../leak-finder/components/VideosTable";
import { useLocationsTableColumns } from "../hooks/useLocationsTableColumns";
import { useLocationsTableData } from "../hooks/useLocationsTableData";

export const DEFAULT_TABLE_PAGE_SIZE = 10;

const LocationsTable = (): JSX.Element => {
  const { rows, loading } = useLocationsTableData();
  const { columns } = useLocationsTableColumns();

  // eslint-disable-next-line
  const handleRowClick = (params: any): void => {
    // Open location modal or redirect to location details/edit page
  };

  return (
    <TableContainer component={TablePaperContainer}>
      <TableFlexContainer>
        <DataGrid
          getRowHeight={() => "auto"}
          sx={dataGridServerStyles.sx}
          pageSizeOptions={[10, 25, 50, 100]}
          rows={rows}
          columns={columns}
          slots={{
            noRowsOverlay: TableNoDataOverlay,
          }}
          onRowClick={handleRowClick}
          columnHeaderHeight={DEFAULT_COLUMN_HEADER_HEIGHT}
          disableRowSelectionOnClick
          hideFooterSelectedRowCount
          getRowId={(row: { rowId: string }): string => row.rowId}
          loading={loading}
          sortingOrder={["desc", "asc"]}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: DEFAULT_TABLE_PAGE_SIZE,
              },
            },
          }}
        />
      </TableFlexContainer>
    </TableContainer>
  );
};

export default LocationsTable;
